@let expanded = menuExpanded();

<aside
  class="relative flex h-full min-h-0 flex-col items-stretch transition-[width] duration-400 ease-in-out"
  [class.w-62]="expanded"
  [class.w-14]="!expanded"
  [attr.aria-expanded]="expanded"
  [attr.aria-label]="'side.mainNavigation' | ksTranslate"
>
  <div class="flex items-center justify-end px-3">
    <button
      ksIconButton
      ksTooltipPlacement="right"
      [iconName]="expanded ? 'menu-close' : 'menu-open'"
      [ariaLabel]="(expanded ? 'side.collapseMenu' : 'side.expandMenu') | ksTranslate"
      [ksTooltip]="(expanded ? 'side.collapseMenu' : 'side.expandMenu') | ksTranslate"
      (click)="menuToggled.emit()"
    ></button>
  </div>

  <nav class="my-3 scrollbar-hidden flex scrollbar min-h-0 flex-auto flex-col overflow-y-auto p-3">
    @for (item of menuItems(); track item.title) {
      @if (item.isSection) {
        <div
          class="mt-4 mb-2 min-h-3 truncate label-2xs font-medium text-neutral-500 uppercase"
          [class.text-left]="expanded"
          [class.text-center]="!expanded"
        >
          {{ expanded ? (item.title | ksTranslate) : '...' }}
        </div>
      } @else {
        <div class="relative">
          <button
            ksButton
            ksTooltipPlacement="right"
            variant="menu"
            color="secondary"
            ksMenuPlacement="right-start"
            class="w-full"
            [prefixIconName]="item.icon"
            [suffixIconName]="expanded && item.children?.length ? 'chevron-right' : undefined"
            [ksTooltip]="item.title | ksTranslate"
            [ksTooltipDisabled]="expanded"
            [activated]="selectedItem()?.title === item.title"
            [ksMenuTrigger]="leafItemsTpl"
            [ksMenuData]="item.children"
            [ksMenuDisabled]="!item.children?.length"
            (click)="selectItem(item)"
          >
            @if (expanded) {
              <div class="flex items-center gap-2">
                <div class="truncate label-xs">{{ item.title | ksTranslate }}</div>

                @if (item.badge) {
                  <ks-badge
                    size="3xs"
                    color="primary"
                  >
                    {{ item.badge | ksTranslate }}
                  </ks-badge>
                }

                @if (item.count) {
                  <ks-badge
                    size="3xs"
                    color="secondary"
                    rounded
                    class="ml-auto"
                  >
                    {{ item.count() }}
                  </ks-badge>
                }
              </div>
            }
          </button>

          @if (!expanded && item.count) {
            <ks-badge
              size="3xs"
              color="secondary"
              rounded
              class="absolute -top-1.5 -right-1.5"
            >
              {{ item.count() }}
            </ks-badge>
          }
        </div>
      }
    }
  </nav>

  @if (companyLogoUrl(); as logoUrl) {
    <div class="flex min-h-8 items-center justify-center border-t border-neutral-200 px-3">
      <img
        class="size-8"
        [src]="logoUrl"
        [alt]="'side.companyLogo' | ksTranslate"
      />
    </div>
  }

  <footer class="flex min-h-8 items-center justify-center border-t border-neutral-200 px-3 label-2xs font-light">
    <span class="text-neutral-500">&copy;{{ currentYear }}</span>

    @if (expanded) {
      <span class="ml-1 truncate">Medido Health LLC</span>
    }
  </footer>
</aside>

<ng-template
  #leafItemsTpl
  let-items
>
  <div
    ksMenu
    class="flex w-60 flex-col px-2 py-4"
  >
    @for (item of items(); track item.title) {
      <button
        ksMenuItem
        ksButton
        variant="menu"
        color="secondary"
        class="w-full"
        (click)="selectItem(item)"
      >
        <div class="text-left label-xs">{{ item.title | ksTranslate }}</div>
      </button>
    }
  </div>
</ng-template>
